/**
 * The game "visual" — cover art with a deterministic gradient fallback. Shared
 * by the gallery {@link GameCard} thumbnail and the game-page landing HERO so
 * the same slug always paints the same art (one source for the formula).
 */

/** Deterministic, distinct thumbnail gradient from a slug (until real per-game
 *  cover art exists — a `coverUrl` the asset pipeline fills). Tuned for the
 *  Sticker Sheet's cream surfaces: saturated candy mid-tones that read as
 *  friendly color blocks inside the ink-outlined frame, capped at a lightness
 *  that keeps the white letter (with its soft shadow) legible on every hue. */
export function slugGradient(slug: string): string {
  let h = 0;
  for (let i = 0; i < slug.length; i += 1) h = (h * 31 + slug.charCodeAt(i)) % 360;
  const h2 = (h + 42) % 360;
  return `linear-gradient(135deg, hsl(${h} 65% 42%), hsl(${h2} 72% 54%))`;
}
